import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import {LeistungProvider} from '../../providers/leistung/leistung';


/**
 * Generated class for the LeistungstextPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-leistungstext',
  templateUrl: 'leistungstext.html',
})
export class LeistungstextPage {
  leistungstext:string;
  mode = {create:true};

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    public leistungCtrl: LeistungProvider) {
    
    this.mode = navParams.data;

    if (this.mode.create){
      this.leistungstext = this.leistungCtrl.leistung.Leistungstext
    }else{
      this.leistungstext = this.leistungCtrl.leistungEdit.Leistungstext
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LeistungstextPage');
  }

  uebernehmen(){
    if (this.mode.create){
      this.leistungCtrl.leistung.Leistungstext = this.leistungstext;
    }else{
      this.leistungCtrl.leistungEdit.Leistungstext = this.leistungstext;
    }
  	this.navCtrl.pop();
  }


}



// WEBPACK FOOTER //
// ./src/pages/leistungstext/leistungstext.ts